import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import '@smartplatform/ui/src/styles/vars.scss';
import { Admin } from '@smartplatform/admin';
import { DragDropContext } from '@smartplatform/ui';

import * as Client from './pages';
import gerb from './img/gerb.png';
import { MENU } from './config';
import { Notification, ACLGrid, DebugLog } from './components';
import store from './store';

import './styles/main.scss';

// Development mode only!!
window.store = store;
// Remove on prod!!!

@observer
class App extends React.Component {
	@observable menu;
	constructor(props) {
		super(props);
		this.init();
	}

	componentDidUpdate() {
		if (!this.menu) {
			this.getMenu();
		};
	};

	init = async () => {
		if (store.model.isAuthorized) {
			console.log('authorized');
			await this.getMenu();
		};
	};

	@action getMenu = async () => {
		//получаем роли пользователя
		const roles = store.model.roles;
		//если в ролях админ - отдаём всё меню
		const isAdmin = roles ? roles.find(item => item === 'admin') : false;
		if (isAdmin) {
			this.menu = MENU;
			return;
		}
		// если не админ, то проверяем по ролям и моделям
		const menu = [];
		//цикл по разделам меню
		for (let MENUItem of MENU) {
			const items = [];
			//цикл по сабпунктам
			for (let item of MENUItem.items) {
				if (item.isVisible && typeof item.isVisible === 'function' && item.isVisible(store.model)) {
					items.push(item);
				}
				//сравниваем сабпункты и роли пользователя
				else if (roles && item.record.roles && item.record.roles.find(item => roles.find(role => role.name === item))) {
					items.push(item)
				}
				//сравниваем сабпункты и модели пользователя
				else if (store.model[item.record.model] && store.model[item.record.model].INFO.WRITE === true) {
					items.push(item)
				}
				// если нет ни ролей ни модели у сабпункта,то добавляем его
				else if ( item.record.roles === undefined && item.record.model === undefined ) {
					items.push(item)
				}
			}
			//если нашли items(сабпункты меню) , то добавляем раздел с ними в меню
			if (items.length !== 0) {
				MENUItem.items = items;
				menu.push(MENUItem);
			}
		}
		this.menu = menu;
	};

	render() {
		const logo = ({ production, version, build }) => (
			<div className="logo">
				<a href={'/'} target="_blank" rel="noopener noreferrer" className="logo__link">
					<img src={gerb} alt="log" />
					<span className="logo__text">
						<p>
							Ил Тумэн <sup>{production ? '' : 'beta'}</sup>
						</p>
						<p>
							{version} ({build})
						</p>
					</span>
				</a>
			</div>
		);
		if (!this.menu) {
			return (
				<Admin
					logo={logo}
					store={store.model}
					rootPath="/admin"
					key={store.model.isAuthorized ? 'authorized' : 'login'}
					history={store.history}
					dashboard={Client.Dashboard}
					menuItems={store.model.isAuthorized ? this.menu : []}
					customUserEdit
					customRoleMappings
				></Admin>
			);
		}

		return (
			<DragDropContext>
				<Admin
					logo={logo}
					store={store.model}
					rootPath="/admin"
					key={store.model.isAuthorized ? 'authorized' : 'login'}
					history={store.history}
					dashboard={Client.Dashboard}
					menuItems={this.menu && this.menu.slice()}
					prependItems={[
						{
							type: 'link',
							record: {
								href: '/admin/mainmenu/info',
								set: 'admin',
								label: 'Главное меню',
								icon: 'list',
							},
						},
						{
							type: 'link',
							record: {
								href: '/admin/users',
								set: 'admin',
								icon: 'user',
								label: 'Пользователи',
							},
						},
						{
							type: 'link',
							record: {
								href: '/admin/rolemappings',
								set: 'admin',
								icon: 'user',
								label: 'Назначенные роли',
							},
						},
					]}
					customUserEdit
					customRoleMappings
				>
					<Notification />
					<Route
						path="/admin/direct-speech/"
						component={() => <Client.Articles type={{ id: 'direct-speech', label: 'Прямая речь' }} />}
					/>
					<Route path="/admin/news/" component={() => <Client.Articles type={{ id: 'news', label: 'Новости' }} />} />
					<Route
						path="/admin/expert-opinion/"
						component={() => <Client.Articles type={{ id: 'expert-opinion', label: 'Экспертное мнение' }} />}
					/>
					<Route path="/admin/galleries/" component={Client.Gallery} />
					<Route path="/admin/media/" component={Client.Media} />
					<Route path="/admin/bills/" component={Client.Bill} />
					<Route path="/admin/awards/" component={Client.Award} />
					<Route path="/admin/awards-information/" component={Client.AwardsInformation} />
					<Route path="/admin/plenarysessions" component={Client.PlenarySession} />
					<Route path="/admin/links/" component={Client.Link} />
					<Route path="/admin/convocations" component={Client.Convocations} />
					<Route path="/admin/deputies" component={Client.Deputies} />
					<Route path="/admin/fractions" component={Client.Fractions} />
					<Route path="/admin/divisiongroups" component={Client.DivisionGroups} />
					<Route path="/admin/divisions" component={Client.Divisions} />
					<Route path="/admin/ticker" component={Client.Ticker} />
					<Route path="/admin/banner-home" component={Client.BannerHome} />
					<Route path="/admin/MainSlides" component={Client.MainSlides} />
					<Route path="/admin/committees" component={Client.Committees} />
					<Route path="/admin/subscriptions" component={Client.Subscription} />
					<Route path="/admin/documents" component={Client.Documents} />
					<Route path="/admin/static" component={Client.StaticPages} />
					<Route path="/admin/itogi" component={Client.Itogi} />
					<Route path="/admin/governance" component={Client.AdmGovernance} />
					<Route path="/admin/discussions" component={Client.Discussions} />
					<Route path="/admin/appeals" component={Client.Appeals} />
					<Route path="/admin/appointments" component={Client.Appointments} />
					<Route path="/admin/councilsessions" component={Client.CouncilSessions} />
					<Route path="/admin/chairperson-workplan" component={Client.ChairmanWorkplan} />
					<Route path="/admin/media-accreditation" component={Client.MediaAccreditation} />
					<Route path="/admin/committeesessions" component={Client.CommitteeSessions} />
					<Route path="/admin/voting" component={Client.Voting} />
					<Route path="/admin/aclgrid" component={ACLGrid} />
					<Route path="/admin/debuglog" component={DebugLog} />
					<Route path="/admin/dispatches" component={Client.Dispatches} />
					<Route path="/admin/baselaws" component={Client.BaseLaw} />
					<Route path="/admin/mainmenu" component={Client.MainMenu} />
					<Route path="/admin/audits" component={Client.Audits} />
					<Route path="/admin/rolemappings" component={Client.RoleMappingTest} />
					<Route path="/admin/users" component={Client.Users} />

					{/* <Route exact path="/admin/articles" component={Client.ArticleList} /> */}
				</Admin>
			</DragDropContext>
		);
	}
}

export default App;
